import { render, staticRenderFns } from "./return.vue?vue&type=template&id=55b84210&scoped=true&"
import script from "./return.vue?vue&type=script&lang=js&"
export * from "./return.vue?vue&type=script&lang=js&"
import style0 from "./return.vue?vue&type=style&index=0&lang=css&"
import style1 from "./return.vue?vue&type=style&index=1&id=55b84210&lang=less&scoped=true&"
import style2 from "@/assets/css/dialog.less?vue&type=style&index=2&id=55b84210&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b84210",
  null
  
)

export default component.exports